import {BREAKPOINT, currentBreakpoint} from './vars/breakpoints'
import {debounce} from 'lodash';
import GridItem from './griditem';

const
 GRID_CONTAINER = 'grid-container',
 GRID_ITEM_HIDDEN = 'grid-item--hidden',
 GRID = 'grid',
 GRID_ITEM = 'grid-item',
 CATEGORIES_ITEM = 'grid-categories__item',
 CATEGORY_FILTER_ALL = 'All',
 ASPECT_RATIO = 1;

class Grid {
  constructor($grid) {
    this.$grid = $grid;
    this.items = [];
    this.$categories = $grid.querySelectorAll(`.${CATEGORIES_ITEM}`);
    this.initialiseElements();
    this.breakpoint = 0;
    this.activeFilter = CATEGORY_FILTER_ALL;
    this.filtering = false;

    this.setUpGridItems();
  }

  initialiseElements() {
    this.$grid
      .querySelectorAll(`.${GRID_ITEM}`)
      .forEach(item => {
        const gridItem = new GridItem(item, this);
        this.items.push(gridItem);
      });
    this.$categories.forEach(
      item => item.addEventListener('click', this.filterBy.bind(this))
    );
    window.addEventListener('resize', debounce(this.setUpGridItems.bind(this), 50))
  }
  
  filterBy(evt) {
    if (this.filtering) {
      return;
    }
    this.filtering = true;
    const item = evt.currentTarget,
      categoryToFilter = item.dataset.category;
    this.activeFilter = categoryToFilter;
    let shownItems = 0;

    this.items.forEach(item => {
      if (categoryToFilter === CATEGORY_FILTER_ALL) {
        item.show();
      } else {
        const
         doesNotMatchFilter = item.$gridItem.dataset.category !== categoryToFilter;
        if (doesNotMatchFilter && !item.isVisible()) {
          // Item is hidden and filter does not match, so keep hidden
          return;
        }
        if (!item.isVisible()) {
          // Item is hidden and filter matches
          item.show();
          this.setMovingItem(item, shownItems);
          shownItems += 1;
          return;
        }
        if (doesNotMatchFilter) {
          // Item showed that does not match the filter
          item.scaleDown();
        } else {
          item.show();
          this.setMovingItem(item, shownItems);
          shownItems += 1;
        }
      }
    });
    if (categoryToFilter == CATEGORY_FILTER_ALL) {
      this.relocateItems();
    }
    this.scaleGridHeight(this.amountOfFilteredItems(categoryToFilter));
    this.filtering = false;
  }

  amountOfFilteredItems(categoryToFilter) {
    if (categoryToFilter === CATEGORY_FILTER_ALL) {
      return this.items.length;
    }
  
    let result = 0;
    this.items.forEach(item => {
      const matchesFilter = item.$gridItem.dataset.category === categoryToFilter;
      if (matchesFilter) {
        result += 1;
      }
    })
    return result;
  }

  scaleGridHeight(amountVisibleItems) {
    const 
      itemsPerRow = this.itemsPerRow(),
      rows = Math.floor((amountVisibleItems / itemsPerRow) + (amountVisibleItems % itemsPerRow > 0 ? 1 : 0)),
      height = this.itemHeight();
    this.$grid.querySelector(`.${GRID}`).style.height = `${rows * height}px`;
  }

  setMovingItem(item, positionInGrid) {
    if (item.hidden) {
      return;
    }
    const
      width = this.itemWidth(), 
      height = this.itemWidth() / ASPECT_RATIO
    const
      col = positionInGrid - this.itemsPerRow() * (Math.floor(positionInGrid / this.itemsPerRow())),
      row = Math.floor(positionInGrid / this.itemsPerRow());
    const 
      toX = width * col,
      toY = height * row,
      currX = item.$gridItem.style.left.split('px')[0],
      currY =  item.$gridItem.style.top.split('px')[0],
      x = toX - currX,
      y = toY - currY;
    item.moveToAnimation(x, y);
  }

  itemWidth() {
    return Math.floor(document.body.clientWidth / this.itemsPerRow());
  }

  itemHeight() {
    return Math.floor(this.itemWidth() / ASPECT_RATIO);
  }

  itemsPerRow() {
    let amount;
    const breakpoint = currentBreakpoint();
    if (breakpoint === BREAKPOINT.SCREEN_PHONE) {
      amount = 1;
    } else if (breakpoint === BREAKPOINT.SCREEN_TABLET) {
      amount = 2;
    } else if (breakpoint === BREAKPOINT.SCREEN_LAPTOP) {
      amount = 4;
    } else {
      amount = 5;
    }
    return amount;
  }

  resizeItems(items, width, height) {
    items.map(item => item.resize(width, height));
  }

  relocateItems() {
    const items = this.items;
    if (items.length === 0) {
      return;
    }
    let i = 0, line = 0;
    items.forEach(item => {
      if (item.hidden) {
        return;
      }
      const x = item.width * i,
        y = item.height * line;
      item.setPosition(x, y);
      
      i += 1;
      if (i === this.itemsPerRow()) {
        line += 1;
        i = 0;
      }
    });
  }

  setUpGridItems() {
    this.breakpoint = currentBreakpoint();
    const amountOfItems = this.amountOfFilteredItems(this.activeFilter);
    this.items.map(item => item.reset());
    this.resizeItems(this.items, this.itemWidth(), this.itemHeight());
    this.relocateItems(amountOfItems);
    this.scaleGridHeight(amountOfItems);
  }
}

export default Grid;

export {GRID_CONTAINER};
